export const SET_USERS = 'SET_USERS';
export const SET_ROLES = 'SET_ROLES';
export const CLEAR_USERS = 'CLEAR_USERS';
